import { IModule, ITKeyApi, ShareStore } from "@tkey-singularity/common-types";

import { post } from "./http";

export const SERVER_STORAGE_MODULE_NAME = "serverStorage";

class ServerStorageModule implements IModule {
  moduleName: string;

  tbSDK: ITKeyApi;

  constructor() {
    this.moduleName = SERVER_STORAGE_MODULE_NAME;
  }

  setModuleReferences(tbSDK: ITKeyApi): void {
    this.tbSDK = tbSDK;
  }

  // eslint-disable-next-line
  async initialize(): Promise<void> {}

  async storeShareOnServerStorage(url: string, share: ShareStore, apikey, bearerToken): Promise<unknown> {
    const body = JSON.stringify({ share });
    const header = {
      credentials: "include",
      withCredentials: true,
      crossDomain: true,
      "x-api-key": apikey,
      authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    };
    return post(url, body, header);
  }

  async inputShareFromServerStorage(serverShare: ShareStore): Promise<unknown> {
    const shareStore = serverShare;
    const latestShareStore = shareStore;
    this.tbSDK.inputShareStore(latestShareStore);
    return {
      latestShareStore: latestShareStore,
    };
  }
}
export default ServerStorageModule;
